import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=ece54b7a&scoped=true"
import script from "./driverDetail.vue?vue&type=script&lang=js"
export * from "./driverDetail.vue?vue&type=script&lang=js"
import style0 from "./driverDetail.vue?vue&type=style&index=0&id=ece54b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece54b7a",
  null
  
)

export default component.exports